import { t } from '@/plugins/i18n'
import { cloneDeep } from 'lodash'
import { JP_GOODS_PURCHASE, JP_GOODS_PURCHASE_HAS_TIKTOK, STOCK_JP_SHIPPING } from '../authCode'
export const mainList = ['CustomerFund']

const usercenter = [
  {
    path: 'user',
    name: 'user',
    meta: {
      title: t('个人中心'),
      icon: 'workbanch',
      layout: 'user'
    },
    component: () => import('@/views/layout/UserLayout.vue'),
    children: [
      {
        path: 'UserCenter',
        name: 'UserCenter',
        meta: {
          title: t('我的工作台')
        },
        component: () => import('@/views/usercenter/UserCenter/index.vue')
      },
      {
        path: 'userCoupons',
        name: 'userCoupons',
        meta: {
          title: t('优惠券'),
          hidden: true
        },
        component: () => import('@/views/usercenter/Coupons/index.vue')
      }

    ]
  }
]

const orderManange = [
  {
    path: 'order',
    name: 'order',
    alwaysShow: true,
    meta: {
      title: t('订单管理'),
      icon: 'order',
      layout: 'user'
    },
    component: () => import('@/views/layout/UserLayout.vue'),
    children: [
      {
        path: 'SyncOrder',
        name: 'SyncOrder',
        meta: {
          title: t('API同步订单'),
          plat: 'd2c',
          site: ['ja', 'ko', 'en']
        },
        component: () => import('@/views/usercenter/Order/SyncOrder/index.vue')
      },
      {
        path: 'OrderList',
        name: 'OrderList',
        meta: {
          title: t('我的订单')
        },
        component: () => import('@/views/usercenter/Order/OrderList/index.vue')
      },
      {
        path: 'ConfirmOrder',
        name: 'ConfirmOrder',
        meta: {
          title: t('确认订单信息'),
          hidden: true
        },
        component: () => import('@/views/usercenter/Order/ConfirmOrder/index.vue')
      },
      {
        path: 'AbnormalOrder',
        name: 'AbnormalOrder',
        meta: {
          title: t('异常订单')
        },
        component: () => import('@/views/usercenter/Order/AbnormalOrder/index.vue')
      },
      {
        path: 'OrderInfo/:id',
        name: 'OrderInfo',
        meta: {
          title: t('订单详情'),
          fpath: 'OrderList',
          hidden: true,
          showBack: false,
          keepAlive: true
        },
        component: () => import('@/views/usercenter/Order/OrderInfo/index.vue')
      },
      {
        path: 'ProductInfo',
        name: 'ProductInfo',
        meta: {
          title: t('商品详情'),
          fpath: 'OrderList',
          hidden: true,
          showBack: true,
          keepAlive: true
        },
        component: () => import('@/views/usercenter/Order/ProductInfo/index.vue')
      },
      {
        path: 'OrderSearch',
        name: 'OrderSearch',
        meta: {
          title: t('商品搜索'),
          fpath: 'OrderList',
          hidden: true,
          showBack: true,
          keepAlive: true
        },
        component: () => import('@/views/usercenter/Order/OrderSearch/index.vue')
      }
    ]
  }
]

const productManange = [
  {
    path: 'product',
    name: 'product',
    alwaysShow: true,
    meta: {
      title: t('商品管理'),
      icon: 'product',
      layout: 'product'
    },
    component: () => import('@/views/layout/UserLayout.vue'),
    children: [
      {
        path: 'stock',
        name: 'stock',
        meta: {
          title: t('库存管理')
        },
        component: () => import('@/views/product/Stock/container.vue')
      },
      {
        path: 'CombinedGoods',
        name: 'CombinedGoods',
        meta: {
          title: t('组合商品管理'),
          site: ['ja']
        },
        component: () => import('@/views/product/CombinedGoods/index.vue')
      },
      {
        path: 'SyncProduct',
        name: 'SyncProduct',
        meta: {
          title: t('同步商品'),
          plat: 'b2b',
          site: ['ja', 'ko']
        },
        component: () => import('@/views/authorized/SyncProduct/index.vue')
      },
      {
        path: 'CrossSyncProduct',
        name: 'CrossSyncProduct',
        meta: {
          title: 'CROSS MALL' + t('同步商品'),
          plat: 'b2b',
          site: ['ja']
        },
        component: () => import('@/views/authorized/CrossSyncProduct/index.vue')
      },
      {
        path: 'brandmanage',
        name: 'BrandManage',
        meta: {
          title: t('品牌授权')
        },
        component: () => import('@/views/brand/auth/Manage.vue')
      },
      {
        path: 'measure',
        name: 'Measure',
        meta: {
          title: t('我的商品测量结果menu')
        },
        component: () => import('@/views/product/Stock/measure.vue')
      },
      {
        path: 'AssociatedProductlib',
        name: 'AssociatedProductlib',
        meta: {
          title: t('关联商品库'),
          plat: 'd2c',
          site: ['ja', 'ko', 'en']
        },
        component: () => import('@/views/product/AssociatedProductlib/index.vue')
      },
      {
        path: 'CreateAssociated',
        name: 'CreateAssociated',
        meta: {
          title: t('创建关联商品'),
          fpath: 'AssociatedProductlib',
          hidden: true,
          plat: 'd2c'
        },
        component: () => import('@/views/product/CreateApiAssociated/index.vue')
      },
      {
        path: 'CollectProduct',
        name: 'CollectProduct',
        meta: {
          title: t('我的收藏')
        },
        component: () => import('@/views/usercenter/ProductList/CollectProduct.vue')
      },
      {
        path: 'AfterPurchase',
        name: 'AfterPurchase',
        meta: {
          title: t('购买过')
        },
        component: () => import('@/views/usercenter/ProductList/AfterPurchase.vue')
      },
      {
        path: 'FootPrint',
        name: 'FootPrint',
        meta: {
          title: t('足迹')
        },
        component: () => import('@/views/usercenter/ProductList/FootPrint.vue')
      },
      {
        path: 'SubstandardList',
        name: 'SubstandardList',
        meta: {
          title: t('次品处理'),
          hidden: true
        },
        component: () => import('@/views/product/substandard/SubstandardList.vue')
      }
    ]
  }
]

const OEM = [
  {
    path: 'oem',
    name: 'oem',
    alwaysShow: true,
    meta: {
      title: t('OEM'),
      icon: 'oem',
      layout: 'oem'
    },
    component: () => import('@/views/layout/UserLayout.vue'),
    // children: [
    //   {
    //     path: '/d2c/oemquest',
    //     name: 'oemQuest',
    //     meta: {
    //       title: t('OEM寻源'),
    //       memberLevel: 2,
    //       plat: 'd2c',
    //       prompt: '我们的 OEM 仅适用于商务舱和头等舱成员。如果您想使用OEM，请从[会员信息]更改会员等级。如果您有任何问题，请联系我们的在线客服。'
    //     },
    //     component: () => import('@/views/oem/Quest/Index.vue')
    //   },
    //   {
    //     path: '/b2b/oemquest',
    //     name: 'oemQuest',
    //     meta: {
    //       title: t('OEM寻源'),
    //       memberLevel: 2,
    //       plat: 'b2b',
    //       prompt: '我们的 OEM 仅适用于商务舱和头等舱成员。如果您想使用OEM，请从[会员信息]更改会员等级。如果您有任何问题，请联系我们的在线客服。'
    //     },
    //     component: () => import('@/views/oem/Quest/Index.vue')
    //   },
    //   {
    //     path: 'SourcingOEM',
    //     name: 'SourcingOEM',
    //     meta: {
    //       title: t('寻源列表'),
    //       memberLevel: 2,
    //       prompt: '我们的 OEM 仅适用于商务舱和头等舱成员。如果您想使用OEM，请从[会员信息]更改会员等级。如果您有任何问题，请联系我们的在线客服。'
    //     },
    //     component: () => import('@/views/oem/SourcingOEM/index.vue')
    //   },
    //   {
    //     path: 'ReorderOEM',
    //     name: 'ReorderOEM',
    //     meta: {
    //       title: t('OEM复购'),
    //       memberLevel: 2,
    //       prompt: '我们的 OEM 仅适用于商务舱和头等舱成员。如果您想使用OEM，请从[会员信息]更改会员等级。如果您有任何问题，请联系我们的在线客服。'
    //     },
    //     component: () => import('@/views/oem/ReorderOEM/index.vue')
    //   },
    //   {
    //     path: 'DetailOEM',
    //     name: 'DetailOEM',
    //     meta: {
    //       title: t('寻源单详情'),
    //       memberLevel: 2,
    //       hidden: true,
    //       showBack: true
    //     },
    //     component: () => import('@/views/oem/DetailOEM/index.vue')
    //   }
    // ]
    children: [
      {
        path: '/oem/order/addFindSource',
        name: 'addFindSource',
        meta: {
          title: t('新增寻源任务'),
          memberLevel: 2,
          plat: 'd2c',
          prompt: '标准舱客户可以提供OEM资材服务。商务舱及以上客户可以提供服装，杂货OEM服务'
        },
        component: () => { }
      },
      {
        path: '/oem/order/addFindSource',
        name: 'addFindSource',
        meta: {
          title: t('新增寻源任务'),
          memberLevel: 2,
          plat: 'b2b',
          prompt: '标准舱客户可以提供OEM资材服务。商务舱及以上客户可以提供服装，杂货OEM服务'
        },
        component: () => { }
      },
      {
        path: '/oem/order/oemSourceList',
        name: 'oemSourceList',
        meta: {
          title: t('寻源列表'),
          memberLevel: 2,
          prompt: '标准舱客户可以提供OEM资材服务。商务舱及以上客户可以提供服装，杂货OEM服务'
        },
        component: () => { }
      },
      {
        path: '/oem/goods/list',
        name: 'goodsList',
        meta: {
          title: t('OEM商品'),
          memberLevel: 2,
          prompt: '标准舱客户可以提供OEM资材服务。商务舱及以上客户可以提供服装，杂货OEM服务'
        },
        component: () => { }
      }
    ]
  }
]

const storeManange = [
  {
    path: 'authorized',
    name: 'authorized',
    alwaysShow: true,
    meta: {
      title: t('店铺管理'),
      icon: 'store',
      layout: 'authorized'
    },
    component: () => import('@/views/layout/UserLayout.vue'),
    children: [
      // {
      //   path: '/d2c/setup/shop',
      //   name: 'setupShop',
      //   meta: {
      //     title: t('店铺配置'),
      //     plat: 'd2c'
      //   },
      //   component: () => import('@/views/setup/SetupShop.vue')
      // },
      // {
      //   path: '/b2b/setup/shop',
      //   name: 'setupShop',
      //   meta: {
      //     title: t('店铺配置'),
      //     plat: 'b2b'
      //   },
      //   component: () => import('@/views/setup/SetupShop.vue')
      // },
      {
        path: 'setupShop',
        name: 'setupShop',
        meta: {
          title: t('店铺配置')
        },
        component: () => import('@/views/setup/Setup.vue')
      },
      {
        path: 'AuthorizedStore',
        name: 'AuthorizedStore',
        meta: {
          title: t('API/子账号配置')
        },
        component: () => import('@/views/authorized/AuthorizedStore/index.vue')
      }
    ]
  }
]

const VipLevel = [
  {
    path: 'vip',
    name: 'vip',
    alwaysShow: true,
    meta: {
      title: t('会员相关'),
      icon: 'vip',
      layout: 'vip'
    },
    component: () => import('@/views/layout/UserLayout.vue'),
    children: [
      {
        path: 'VipLevel',
        name: 'VipLevel',
        meta: {
          title: t('会员办理'),
          noShopAccess: true
        },
        component: () => import('@/views/usercenter/VipLevel/index.vue')
      },
      {
        path: 'Information',
        name: 'Information',
        meta: {
          title: t('消息')
        },
        component: () => import('@/views/usercenter/Information/index.vue')
      },
      {
        path: 'RenewalCourse',
        name: 'RenewalCourse',
        meta: {
          title: t('关闭paypal自动续费教程'),
          hidden: true
        },
        component: () => import('@/views/usercenter/RenewalCourse/index.vue')
      },
      {
        path: 'setupUser',
        name: 'setupUser',
        meta: {
          title: t('登录账号管理')
        },
        component: () => import('@/views/setup/SetupTabs.vue')
      }
    ]
  }
]

const inshipping = [
  {
    path: 'inshipping_d2c',
    name: 'inshipping_d2c',
    alwaysShow: true,
    meta: {
      title: t('国际配送管理'),
      icon: 'inShipping',
      layout: 'inshipping',
      plat: 'd2c',
      showAuth: [STOCK_JP_SHIPPING]
    },
    component: () => import('@/views/layout/UserLayout.vue'),
    children: [
      {
        path: 'ShippingList_d2c',
        name: 'ShippingList_d2c',
        meta: {
          title: '搬送依赖一覧'
        },
        component: () => import('@/views/inshipping/ShippingList/index.vue')
      }
    ]
  },
  {
    path: 'inshipping',
    name: 'inshipping',
    alwaysShow: true,
    meta: {
      title: t('国际配送管理'),
      icon: 'inShipping',
      layout: 'inshipping',
      plat: 'b2b'
    },
    component: () => import('@/views/layout/UserLayout.vue'),
    children: [
      {
        path: 'ReplenishmentList',
        name: 'ReplenishmentList',
        meta: {
          title: t('FBA补货计划'),
          site: ['ja']
        },
        component: () => import('@/views/inshipping/ReplenishmentList/index.vue')
      },
      {
        path: 'ShippingList',
        name: 'ShippingList',
        meta: {
          title: t('国际发货管理')
        },
        component: () => import('@/views/inshipping/ShippingList/index.vue')
      },
      {
        path: 'CreateShipping',
        name: 'CreateShipping',
        meta: {
          title: t('创建国际发货'),
          fpath: 'ShippingList',
          hidden: true,
          showBack: true
        },
        component: () => import('@/views/inshipping/CreateShipping/index.vue')
      },
      {
        path: 'ShippingInfo',
        name: 'ShippingInfo',
        meta: {
          title: t('国际发货详情'),
          fpath: 'ShippingList',
          hidden: true,
          keepAlive: true,
          showBack: true
        },
        component: () => import('@/views/inshipping/ShippingInfo/index.vue')
      },
      {
        path: 'CreateReplenishment',
        name: 'CreateReplenishment',
        meta: {
          title: t('创建补货计划'),
          fpath: 'ReplenishmentList',
          hidden: true,
          showBack: true
        },
        component: () => import('@/views/inshipping/CreateReplenishment/index.vue')
      },
      {
        path: 'AfterSale',
        name: 'AfterSale',
        meta: {
          title: t('国际发货售后')
        },
        component: () => import('@/views/inshipping/AfterSales/index.vue')
      }
    ]
  }
]

const purchase = [
  {
    path: 'purchaseManage',
    name: 'purchaseManage',
    alwaysShow: true,
    meta: {
      title: t('采购管理'),
      icon: 'purchase',
      layout: 'purchase',
      plat: 'd2c',
      // 只有满足条件才会展示，没有值默认展示
      showAuth: [JP_GOODS_PURCHASE, JP_GOODS_PURCHASE_HAS_TIKTOK]
      // 只有满足条件才隐藏，没有值默认展示
      // hiddenAuth: [JP_GOODS_PURCHASE]
    },
    component: () => import('@/views/layout/UserLayout.vue'),
    children: [
      {
        path: 'list',
        name: 'purchaseManageList',
        meta: {
          title: t('日本商品采购计划'),
          showAuth: [JP_GOODS_PURCHASE_HAS_TIKTOK]
        },
        component: () => import('@/views/usercenter/purchaseManage/list.vue')
      }, {
        path: 'EntrySchedule',
        name: 'EntrySchedule',
        meta: {
          plat: 'd2c',
          title: '入荷予定（日本倉庫）',
          site: ['ja'],
          showAuth: [JP_GOODS_PURCHASE_HAS_TIKTOK],
        },
        component: () => import('@/views/usercenter/Order/EntrySchedule/index.vue')
      },
      {
        path: 'EntryInfo/:inboundCode',
        name: 'EntryInfo',
        meta: {
          title: t('转运订单详情'),
          fpath: 'EntrySchedule',
          plat: 'd2c',
          site: ['ja'],
          hidden: true,
          showBack: false
        },
        component: () => import('@/views/usercenter/Order/EntrySchedule/detail.vue')
      }
    ]
  }
]
const costCalc = [
  {
    path: 'costCalc',
    name: 'costCalc',
    alwaysShow: true,
    meta: {
      name: 'new-calc',
      title: t('应用工具'),
      icon: 'applicationTool',
      layout: 'fund'
    },
    component: () => import('@/views/layout/UserLayout.vue'),
    children: [
      {
        path: 'list',
        name: 'costCalcList',
        meta: {
          title: t('成本计算器')
        },
        component: () => import('@/views/microapp/BackBoard.vue')
      }
    ]
  }
]

const fund = [
  {
    path: 'fund',
    name: 'fund',
    alwaysShow: true,
    meta: {
      title: t('资金管理'),
      icon: 'fund',
      layout: 'fund'
    },
    component: () => import('@/views/layout/UserLayout.vue'),
    children: [
      {
        path: 'CustomerFund',
        name: 'CustomerFund',
        meta: {
          title: t('资金明细')
        },
        component: () => import('@/views/fund/FundList/index_ref.vue')
      },
      {
        path: 'StoreFund',
        name: 'StoreFund',
        meta: {
          title: t('资金明细')
        },
        component: () => import('@/views/fund/FundList/index_ref.vue')
      },
      {
        path: 'BillList',
        name: 'BillList',
        meta: {
          title: t('我的账单')
        },
        component: () => import('@/views/fund/FundList/BillList.vue')
      },
      {
        path: 'Recharge',
        name: 'Recharge',
        meta: {
          title: t('充值'),
          hidden: true
        },
        component: () => import('@/views/fund/FundList/Recharge.vue')
      }
    ]
  }
]

const user = [
  ...usercenter,
  ...orderManange,
  ...productManange,
  ...inshipping,
  ...purchase,
  ...fund,
  ...OEM,
  ...storeManange,
  ...VipLevel,
  ...costCalc
]

const setRouter = (routes: any, plat: string, site: string) => {
  const newRoute = cloneDeep(routes)
  // (function setRt (val) {
  //   for (let i = 0; i < val.length; i++) {
  //     const t = val[i]
  //     if ((t?.meta?.plat && t.meta.plat !== plat) || (t?.meta?.site && !t.meta.site.includes(site))) {
  //       val.splice(i--, 1)
  //     }
  //     if (t?.children && t.children.length > 0) {
  //       setRt(t.children)
  //     }
  //   }
  // })(newRoute)
  const setRt = (routes: any) => {
    return routes.filter((t: any) => {
      if (t.children) {
        t.children = setRt(t.children)
      }
      return !((t?.meta?.plat && t.meta.plat !== plat) || (t?.meta?.site && !t.meta.site.includes(site)))
    })
  }
  return setRt(newRoute)
}

export const setUserRouter = (plat: string, site: string) => setRouter(user, plat, site)
export default user
